import React from 'react';
import { compose } from 'recompose';
import {
  Box,
  Typography,
  Grid,
  MenuItem,
  FormControl,
  Select,
  OutlinedInput, FormHelperText
} from '@mui/material';
import TextField from '@mui/material/TextField';
import { pathOr, map } from 'ramda';
import { Controller } from 'react-hook-form';
import { STATE_LIST } from 'src/features/constants';

interface Props {
  address: any;
  control: any;
  errors: any;
  setSuite?: any;
}
type CombinedProps = Props;
const AddressFields: React.FC<CombinedProps> = (props: CombinedProps) => {
  const { control, errors, setSuite } = props;
  const rules = {
    required: {
      value: true,
      message: 'This field is required',
    },
  };

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={8}>
        <Box>
          <Typography variant="body2" mb={1}>
            Street and number
          </Typography>

          <Controller
            name='street'
            control={control}
            rules={rules}
            render={({ field: { onChange, value } }) =>
              <TextField
                type="text"
                value={value}
                fullWidth
                onChange={onChange}
                error={Boolean(errors?.street)}
                helperText={errors?.street?.message}
                inputProps={{ "data-test-id": "--t-street" }}

              />
            }
          />
        </Box>
      </Grid>
      <Grid item xs={4}>
        <Box>
          <Typography variant="body2" mb={1}>
            Apt/Unit#
          </Typography>

          <Controller
            name="suit"
            control={control}
            render={({ field: { onChange, value } }) =>
              <TextField
                type="text"
                value={value}
                fullWidth
                inputProps={{ "data-test-id": "--t-unit" }}
                onChange={(event) => {
                  onChange(event);
                  setSuite && setSuite(value);
                }}
              />
            }
          />
        </Box>
      </Grid>{' '}
      <Grid item xs={12}>
        <Box>
          <Typography variant="body2" mb={1}>
            City
          </Typography>

          <Controller
            name="city"
            control={control}
            rules={rules}
            render={({ field: { onChange, value } }) =>
              <TextField
                type="text"
                fullWidth
                value={value}
                inputProps={{ "data-test-id": "--t-city" }}

                onChange={onChange}
                error={Boolean(errors?.city)}
                helperText={errors?.city?.message}
              />}
          />
        </Box>
      </Grid>
      <Grid item xs={8}>
        <Box>
          <Typography variant="body2" mb={1}>
            State
          </Typography>
          <Controller
            name="state"
            control={control}
            rules={rules}
            render={({ field: { onChange, value } }) =>
              <FormControl
                fullWidth
                error={Boolean(errors?.state)}>
                <Select
                  value={value}
                  title={'state'}
                  onChange={onChange}
                  input={<OutlinedInput size="medium" />}
                  inputProps={{ "data-test-id": "--t-state" }}


                >
                  {map(
                    (item: any) => (
                      <MenuItem value={pathOr('', ['value'], item)}>
                        {pathOr('', ['label'], item)}
                      </MenuItem>
                    ),
                    STATE_LIST
                  )}
                </Select>
                {Boolean(errors?.state) && <FormHelperText>{errors?.state?.message}</FormHelperText>}
              </FormControl>
            }
          />
        </Box>
      </Grid>
      <Grid item xs={4}>
        <Box>
          <Typography variant="body2" mb={1}>
            Zip code{' '}
          </Typography>
          <Controller
            name="zipcode"
            control={control}
            rules={{
              required: 'This field is required',
              pattern: {
                value: /^\d{5}(-\d{4})?$/,
                message: 'Please enter a valid zip code',
              },
            }}
            render={({ field: { onChange, value } }) =>
              <TextField
                type="text"
                value={value}
                fullWidth
                inputProps={{ "data-test-id": "--t-zip" }}
                onChange={onChange}
                error={Boolean(errors?.zipcode)}
                helperText={errors?.zipcode?.message}
              />
            }
          />
        </Box>
      </Grid>
    </Grid>
  );
};

const enhanced = compose(AddressFields);

export default enhanced;
